import { PresetObj } from "../../api-entities/PresetArea";
import { config } from "../../config";
import { makeAreaObj } from "../../entities/Area";
import { makeUser, User, UserType } from "../../entities/User";
import { Action, Thunk } from "../actions/All";
import { UserAction } from "../actions/UserActions";
import { ActionType } from "../ActionTypes";
import { fetchUserAreas, getUserDetails } from "./RemoteActionCreators";

const logOut = (): Action => ({
	type: ActionType.LOG_OUT
});

export const getUserAreas: Thunk = async (dispatch, _) => {
	try {
		const presets = await dispatch(fetchUserAreas);
		dispatch(setUserPresetAreas(presets.map(makeAreaObj)));
	} catch {
		throw new Error("There was an error retrieving user areas");
	}
};

const logIn = (user: User): Thunk => dispatch => {
	dispatch({
		type: ActionType.LOG_IN,
		user
	});

	// Fetch user preset areas
	dispatch(getUserAreas);
};

/**
 * Logs the user in if possible. Otherwise won't do anything.
 */
export const silentLogin: Thunk = async dispatch => {
	try {
		const raw = await dispatch(getUserDetails);
		const user = makeUser(raw);
		dispatch(logIn(user));
	} catch (error) {
		dispatch(logOut());
	}
};

/**
 * Tries to login as a particular type of user.
 * Should only be used in development.
 */
export const devLogin = (type: UserType): Thunk => dispatch => {
	const token = config.tokens.get(type)!;

	dispatch({
		type: ActionType.SET_USER_TOKEN,
		token
	});

	dispatch(silentLogin);
};

export const setUserPresetAreas: (newPresets: PresetObj[]) => UserAction = newPresets => ({
	type: ActionType.SET_USER_PRESET_AREAS,
	areas: newPresets
});
